import { FC, InputHTMLAttributes, forwardRef } from 'react'
import styled, { css } from 'styled-components'

interface IFProps extends InputHTMLAttributes<HTMLInputElement> {
  errorMessage?: string
  isErrors?: boolean
}

const PredictionInputText: FC<IFProps> = forwardRef<HTMLInputElement, IFProps>(
  ({ type = 'text', isErrors, ...restInputProps }, inputTextRef) => {
    return (
      <StyledWrapper>
        <input
          type={type}
          ref={inputTextRef}
          className={isErrors ? 'error' : ''}
          {...restInputProps}
        />
      </StyledWrapper>
    )
  },
)

export default PredictionInputText

const StyledWrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 100%;
    min-height: 50px;

    & > input {
      width: 100%;
      height: 50px;
      padding: 13px 15px;
      border-radius: 8px;
      border: solid 1px ${theme.line.line_2};
      background-color: ${theme.background.bg_8};
      font-family: Noto Sans KR;
      font-size: 16px;
      font-weight: 500;
      letter-spacing: -0.64px;
      text-align: left;
      color: ${theme.color.text_1};

      &:focus {
        outline: none;
      }

      &::placeholder {
        color: ${theme.color.text_3};
        font-weight: normal;
      }

      &:disabled {
        background-color: ${theme.background.bg_3};
        color: ${theme.color.text_2};
      }

      &:read-only {
        background-color: ${theme.background.bg_3};
        pointer-events: none;
      }

      &[type='number'] {
        -moz-appearance: textfield; // Firefox용 input number 증감 버튼 hidden

        &::-webkit-inner-spin-button, // webkit 기반 (크롬, 사파리)용 input number 증감 버튼 hidden
        &::-webkit-outer-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
      }

      &.error {
        color: ${theme.color.error_1};
        border: solid 1px ${theme.color.error_1};
      }
    }
  `}
`
